import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Authenticating...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      // Direct token login
      localStorage.setItem('token', token);
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => {
          localStorage.setItem('user', JSON.stringify(res.data));
          setStatus('Logged in. Redirecting...');
          window.location.href = '/';
        })
        .catch(() => {
          setStatus('Invalid token.');
        });
      return;
    }

    // Bootstrap key + email flow
    const key = searchParams.get('key');
    const email = searchParams.get('email');
    if (key && email) {
      axios.get(`${API}/admin/auto-login`, { params: { bootstrap_key: key, email } })
        .then(res => {
          localStorage.setItem('token', res.data.token);
          return axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${res.data.token}` } });
        })
        .then(res => {
          localStorage.setItem('user', JSON.stringify(res.data));
          setStatus('Logged in. Redirecting...');
          window.location.href = '/';
        })
        .catch(err => {
          setStatus(err.response?.data?.detail || 'Auto-login failed.');
        });
      return;
    }

    setStatus('Missing parameters. Use ?key=...&email=... or ?token=...');
  }, [searchParams, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'system-ui' }}>
      <p data-testid="auto-login-status">{status}</p>
    </div>
  );
}
